var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"made-by-component text--center pb-3"},[_c('span',[_vm._v(" ©2019. Made by "),_c('a',{staticClass:"link",attrs:{"href":"https://epicmax.co"}},[_vm._v("Epicmax")])])])
}]

export { render, staticRenderFns }